import { render, staticRenderFns } from "./Prospect.vue?vue&type=template&id=0cf7f6e1&scoped=true&lang=true"
import script from "./Prospect.vue?vue&type=script&lang=js"
export * from "./Prospect.vue?vue&type=script&lang=js"
import style0 from "./Prospect.vue?vue&type=style&index=0&id=0cf7f6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7f6e1",
  null
  
)

export default component.exports